<template>
    <div>
        <div class='container'>
            <el-form ref='userForm' :model='produce' class='demo-form-inline'>
                <el-form-item label="所属项目" prop="produce">
                    <el-select v-model="produce.projectName" filterable value-key="projectId"
                        class="handle-select mr10">
                        <el-option v-for="val in projects" :key="val.id" :value="val.name"
                            :label="val.cnName"></el-option>
                    </el-select>
                </el-form-item>
                <div>
                    <el-form-item label="商品名称" prop="produce">
                        <el-input v-model='produce.name' placeholder='输入商品名称' style='width: 260px;'></el-input>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item label='商品ID' prop='produce'>
                        <el-input v-model='produce.productId' placeholder='商品ID 如com.cotton.xx'
                                  style='width: 260px;'></el-input>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item label="商品价格" prop="produce">
                        <el-input v-model='produce.price' placeholder='请输入商品价格' style='width: 260px;'></el-input>
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label='购买发放数量' prop='produce'>
                        <el-input v-model='produce.produceCount' placeholder='如用户购买后, 向用户发放1000金币'
                                  style='width: 260px;'></el-input>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item label="商品折扣" prop="produce">
                        <el-input v-model="produce.discount" placeholder="" style="width: 260px;"></el-input> （100是原价，90是九折）
                    </el-form-item>
                </div>

                <div>
                    <el-form-item label="商品类型" prop="produce">
                        <el-select v-model="produce.type" placeholder="商品类型" class="handle-select mr10">
                            <el-option v-for="item in produceType" :label="item.label" :key="item.value" :value="item.value"/>
                        </el-select>
                    </el-form-item>
                </div>
                
                <br>
                <el-divider content-position='center'>其他属性</el-divider>
                
                <!--<div>-->
                <!--    <el-form-item label="是否限购" prop="produce">-->
                <!--        <el-select v-model="produce.limitationType" placeholder="不限购" class="handle-select mr10">-->
                <!--            <el-option key="" value="0" label="不限购"></el-option>-->
                <!--            <el-option v-for="val in limitList" :key="val.value" :value="val.value"-->
                <!--                :label="val.label"></el-option>-->
                <!--        </el-select>-->
                <!--    </el-form-item>-->
                <!--</div>-->
                <!--<div>-->
                <!--    <el-form-item label="限购数量" prop="produce">-->
                <!--        <el-input v-model="produce.limitationCount" placeholder="" style="width: 260px;"></el-input>-->
                <!--    </el-form-item>-->
                <!--</div>-->
                
                <el-form-item label='登录购买限制' prop='produce'>
                    <el-switch
                        v-model='produce.loginLimit'
                        active-text='需要登录'
                        inactive-text='不需要登录'>
                    </el-switch>
                </el-form-item>
                
                <el-form-item label='上架平台列表'>
                    <div>
                        <el-tag
                            :key='tag'
                            v-for='tag in productChannels'
                            closable
                            size='mini'
                            style='margin-right: .5rem;'
                            :disable-transitions='false'
                            @close='handleClose(tag)'>
                            {{ tag }}
                        </el-tag>
                        <el-input
                            class='input-new-tag'
                            v-if='productChannelInputVisible'
                            v-model='productInputChannel'
                            ref='saveTagInput'
                            size='mini'
                            style='max-width: 7rem;'
                            @keyup.enter.native='handleInputConfirm'
                            @blur='handleInputConfirm'
                        >
                        </el-input>
                        <el-button v-else class='button-new-tag' size='mini' @click='showInput'>+ 新渠道(默认全渠道)
                        </el-button>
                    </div>
                </el-form-item>
                <div>
                    <el-form-item label='商品描述' prop='produce'>
                        <el-input v-model='produce.description' placeholder='请输入商品描述(可选)'
                                  style='width: 500px;'></el-input>
                    </el-form-item>
                </div>
                
                <br>
                <el-divider content-position='center'>云存储配置(非必须)</el-divider>
                <product-shipping-config @submitConfig='handleSubmitConfig' :project-info-list='projects'
                                           :project-name='produce.projectName' />

                <el-form-item>
                    <el-button type="primary" @click="submitProduce()">新增商品</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { apiProduceInster } from '../../api/produce.js';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { message } from '@/utils/message';
import ProductShippingConfig from '@/components/component/product/ProductShippingConfig.vue';

export default {
    name: 'AlipayCheck',
    components: { ProductShippingConfig },
    data: function () {
        return {
            result: null,
            produce: {
                name: "",
                price: 0,
                description: "",
                projectName: undefined,
                type: 0,
                discount: 100,
                priceDiscount: 0,
                produceCount: 0,
                productId: "",
                limitationType: '0',
                limitationCount: 0,
                additionalConfig: undefined,
                loginLimit: true
            },
            query: {
                projectName: '', // 下拉框值
                deviceId: '',    // 搜索框
            },
            projects: [], //下拉框集合
            limitList: [{
                value: '1',
                label: '每日限购'
            }, {
                value: '2',
                label: '每周限购'
            }, {
                value: '3',
                label: '每月限购'
            }, {
                value: '4',
                label: '永久限购'
            }],
            
            // 商品类型
            produceType: [
                {
                    label: '普通道具',
                    value: 0
                },
                {
                    label: '买断道具',
                    value: 1
                }
            ],
            productChannels: [],
            productInputChannel: undefined,
            productChannelInputVisible: false


        }
    },
    created() {
        this.getProjectName()

    },
    methods: {
        //下拉框名称信息
        getProjectName() {
            queryProjectInfoList({pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.projects = result.data.result
                }
            })
        },
        //下拉框动作
        current(event) {
            this.produce.projectName = event.projectName
        },
       

        submitProduce() {
            if (this.produce.type != 0 && this.produce.type != 1) {
                alert("商品类型错误，请核对后重试");
                return;
            }

            let discountPrice = this.produce.discount * 0.01 * this.produce.price;
            let params = {
                'name': this.produce.name, 'price': this.produce.price,
                produceCount: this.produce.produceCount,
                additionalConfig: this.produce.additionalConfig,
                'description': this.produce.description, 'projectName': this.produce.projectName,
                'type': this.produce.type, 'discount': this.produce.discount, 'priceDiscount': discountPrice,
                'productId': this.produce.productId, 'limitationType': this.produce.limitationType,
                'limitationPurchaseCount': this.produce.limitationCount, 'loginLimit': this.produce.loginLimit
            }
            try {
                params.channels = JSON.stringify((this.productChannels));
            } catch (e) {
            }
            
            apiProduceInster(params).then(res => {
                if (res.status == 200) {
                    message.success('添加成功');
                    this.productChannels = [];
                    this.productInputChannel = undefined;
                }
            })
        },
        handleSubmitConfig(value) {
            if (value) {
                this.produce.additionalConfig = value;
            }
        },
        
        
        handleClose(tag) {
            this.productChannels.splice(this.productChannels.indexOf(tag), 1);
        },
        
        showInput() {
            this.productChannelInputVisible = true;
            this.$nextTick(_ => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        
        handleInputConfirm() {
            let inputValue = this.productInputChannel;
            if (this.productChannels.indexOf(inputValue) !== -1) {
                message.error('渠道已存在');
                this.productInputChannel = '';
                return;
            }
            if (inputValue) {
                this.productChannels.push(inputValue);
            }
            this.productChannelInputVisible = false;
            this.productInputChannel = '';
        }
    }
}

</script>
